import { Success16, UIText1 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './MapRows.css';

export interface IMapRowsProps {
  items: Array<{
    id: string;
    text: string;
    IconComponent: React.FunctionComponent;
  }>;
  onRowClick?: (rowId: string) => void;
  selectedItemId?: string;
  hasHover?: boolean;
}

// TODO: Будет допокрыто в рамках CD-170051.
/* istanbul ignore next */
export const MapRows: React.FC<IMapRowsProps> = ({ items, onRowClick, selectedItemId, hasHover = true }) => {
  const handleRowClick = React.useCallback(
    (rowId: string) => {
      if (onRowClick) {
        onRowClick(rowId);
      }
    },
    [onRowClick],
  );

  return (
    <>
      {items.map(item => {
        const { IconComponent, id, text } = item;

        return (
          <div
            key={id}
            className={classNames(styles['row'], hasHover && styles['has-hover'])}
            role="button"
            onClick={() => handleRowClick(id)}
          >
            <IconComponent />
            <div className={styles['text']}>
              <UIText1>{text}</UIText1>
              {selectedItemId === id && (
                <div className={styles['success-icon-wrapper']}>
                  <Success16 color="primary_100" />
                </div>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};
